import { render, staticRenderFns } from "./List.vue?vue&type=template&id=6730f1b8&scoped=true"
import script from "./List.vue?vue&type=script&setup=true&lang=ts"
export * from "./List.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./List.vue?vue&type=style&index=0&id=6730f1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6730f1b8",
  null
  
)

export default component.exports